import MotionController from "../lib/motion_controller"
import { gsap, EASE } from "../lib/motion"

// Plays a one-shot entrance when the element scrolls into view.
//   data-controller="reveal"
//   data-reveal-y-value="24" data-reveal-scale-value="1" data-reveal-stagger-value="0.06"
//   data-reveal-target="item" on children to stagger them (defaults to the element itself).
export default class extends MotionController {
  static targets = [ "item" ]
  static values = {
    y: { type: Number, default: 24 },
    scale: { type: Number, default: 1 },
    stagger: { type: Number, default: 0.06 },
    duration: { type: Number, default: 0.9 },
    delay: { type: Number, default: 0 },
    start: { type: String, default: "top 82%" }
  }

  animate({ motion }) {
    if (!motion) return

    const items = this.hasItemTarget ? this.itemTargets : [ this.element ]
    gsap.from(items, {
      autoAlpha: 0,
      y: this.yValue,
      scale: this.scaleValue,
      duration: this.durationValue,
      delay: this.delayValue,
      stagger: this.staggerValue,
      ease: EASE.out,
      scrollTrigger: { trigger: this.element, start: this.startValue, once: true }
    })
  }
}
